export class CatalogFiltersListSearch {
	private inputElement: HTMLInputElement;
	private wrapper: HTMLElement;
	private list: HTMLElement;
	private button: HTMLButtonElement;

	constructor(element: HTMLInputElement) {
		this.inputElement = element;
		this.init();
	}

	private init = (): void => {
		this.wrapper = this.inputElement.closest('.js-filter-checkbox-list');
		this.list = this.wrapper.querySelector('.filter-checkbox-list__list-wrapper');
		this.button = this.wrapper.querySelector('.js-list-expand');

		this.checkHeight();
		this.inputElement.addEventListener('input', () => this.inputHandler());
		this.inputElement.addEventListener('change', () => this.inputHandler());
	};

	private inputHandler = (): void => {
		const inputValue = this.inputElement.value.toLocaleLowerCase();

		this.list.querySelectorAll('.filter-checkbox-list__element-wrapper span')
			.forEach((item) => {
				const itemValue = item.innerHTML.toLocaleLowerCase();
				if (itemValue.match(inputValue)) {
					item.closest('.filter-checkbox-list__element-wrapper').classList.remove('hidden');
				} else {
					item.closest('.filter-checkbox-list__element-wrapper').classList.add('hidden');
				}
			});

		this.checkHeight();
	};

	private checkHeight(): void {
		const visibleItems = this.list.querySelectorAll('.filter-checkbox-list__element-wrapper:not(.hidden)');
		if (visibleItems.length < 6) {
			this.wrapper.classList.add('float-height');
		} else {
			this.wrapper.classList.remove('float-height');
		}
	}
}
